export default "__VITE_ASSET__JV7LS9Mf__"